import {
  CalendarToday,
  LocationSearching,
  MailOutline,
  PermIdentity,
  PhoneAndroid,
  Publish,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import "./user.css";

export default function User15_18_19MultiBrain() {
  return (
    <div className="user">
      <div className="userTitleContainer">
        <h1 className="userTitle">Model Details</h1>
        <Link to="/newUser">
          {/* <button className="userAddButton">Create</button> */}
        </Link>
      </div>
      <div className="userContainer">
        <div className="userShow">

          <div className="userShowBottom">
            <span className="userShowTitle">Data Details</span>
            <div className="userShowInfo">
              <PermIdentity className="userShowIcon" />
              <span className="userShowInfoTitle">Accuracy: 99.98% </span>
            </div>
            <div className="userShowInfo">
              <PermIdentity className="userShowIcon" />
              <span className="userShowInfoTitle">Predictions : multipleBrainPredictions</span>
            </div>
            <div className="userShowInfo">
              <PhoneAndroid className="userShowIcon" />
              <span className="userShowInfoTitleBold">Data Credentials:</span>
              <a className="userShowInfoTitle" target="_blank" href ="https://www.kaggle.com/" > Kaggle MutlipleBrainCancerPredictions </a>
            </div>
            <div className="userShowInfo">
              <MailOutline className="userShowIcon" />
              <span className="userShowInfoTitleBold">Training Data Preview:</span>
              <a className="userShowInfoTitle" target="_blank" href ="https://www.kaggle.com" > Google Drive - MultiBrain (TBC, Train)</a>
              </div>
          </div>
        </div>
     </div>
    </div>
  );
}